import { FC, memo } from 'react'

import { BreadCrumbsProps } from './BreadCrumbsProps'

import * as SC from './styles'

export const BreadCrumbs: FC<BreadCrumbsProps> = memo(({ licenseNumber, licenseName }) => (
  <SC.Box>
    <SC.Connections to="/key-connections">Connections</SC.Connections>
    <SC.Arrow>&gt;</SC.Arrow>
    <SC.Wrapper>
      {licenseName} ({licenseNumber})
    </SC.Wrapper>
  </SC.Box>
))
